
import EventBus from '../common/eventbus';

export default {
	name: 'PageLoader',
	data() {
		return {
			show: true
		};
	},
	mounted() {
		EventBus.$on('toggle-loader', this.setLoader);
	},
	methods: {
		setLoader(state) {
			this.show = state;
		}
	}
};
